import React from 'react'
import { Modal, Divider } from 'antd'
import { connect } from 'react-redux'
import classNames from 'classnames'
import ButtonPurple from 'components/design/Form/ButtonPurple'
// import { getTrialLeftInDays } from 'helpers'
import style from './style.module.scss'

const mapStateToProps = ({ settings: { visibleModalID } }) => ({ visibleModalID })

@connect(mapStateToProps)
class ModalScheduleDeleted extends React.Component {
  handleCancel = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'apps/REDIRECT_DELETED_APPS',
    })
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  render() {
    const { visibleModalID } = this.props
    const modalID = 'sheduledTodelete'
    const visible = modalID === visibleModalID

    return (
      <Modal
        className="custom__form__modal"
        title={false}
        open={visible}
        onCancel={this.handleCancel}
        footer={false}
        afterClose={this.handleCancel}
        maskClosable={false}
      >
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className={classNames(style.deletedAppContainer)}>
              <div className={style.headerMain}>
                <h1>This app has been scheduled for deletion</h1>
              </div>
              <Divider style={{ margin: '20px -24px', width: '110%' }} />

              <div className={style.bodyMain}>
                <p className={style.body}>
                  This app has been disabled and is scheduled to delete. To restore your app, please
                  contact us.
                </p>
              </div>
              <Divider style={{ margin: '20px -24px', width: '110%' }} />
              <div className={style.footerMain}>
                <a
                  href="https://help.cometchat.com/hc/en-us/requests/new"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={style.topLink}
                >
                  <ButtonPurple buttonText="Contact Us" holderStyles={{ width: 'fit-content' }} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalScheduleDeleted
